<template>
	<base-form class="w-full" ref="courseEditForm" :fields-in-row="3" :form-data="courseForm" :edit-record="golfCourse" @submitted="edit"></base-form>
</template>
<script>
/** @format */
import CourseFields from '@/fields/courses';
export default {
	name: 'CoursesForm',
	props: {
		golfCourse: {
			type: Object,
			required: true
		}
	},
	methods: {
		edit(payload) {
			this.$store.dispatch('notification/add', {type: 'info', message: 'Saving tee data.'});
			this.$store
				.dispatch('courses/edit', { golfCourse: this.golfCourse, payload })
				.then((response) => {
					this.$emit('course-updated', response.data.data)
					this.$store.dispatch('notification/add', {type: 'success', message: 'Course updated successfully.'});
				})
				.finally(() => {
					this.$refs.courseEditForm.cancelSubmit();
				});
		},
	},
	data() {
		return {
			courseForm: JSON.parse(JSON.stringify(CourseFields)),
		}
	}
};
</script>
